import { render, staticRenderFns } from "./ViewAssignGroup.vue?vue&type=template&id=7627c24b&scoped=true&"
import script from "./ViewAssignGroup.vue?vue&type=script&lang=js&"
export * from "./ViewAssignGroup.vue?vue&type=script&lang=js&"
import style0 from "./ViewAssignGroup.vue?vue&type=style&index=0&id=7627c24b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7627c24b",
  null
  
)

export default component.exports